export default __webpack_public_path__ + "static/media/turkey_black_female.a059754b.png";